module.exports = __webpack_public_path__ + "static/media/Vincent Crabbe 3.7f062b01.jpg";